import styled from "@emotion/styled";

import { fontFredoka, theme } from "shared/lib/styles";

import { AuthorAvatar } from "scmp-app/components/author/author-avatar";
import { StyledEntityLink } from "scmp-app/components/author/author-avatar/styles";
export const Container = styled.div`
  inline-size: 99px;
  ${theme.breakpoints.up("tablet")} {
    inline-size: 166px;
  }
`;

export const AuthorAvatarContainer = styled.div`
  position: relative;

  margin-block-end: 12px;
`;

export const StyledAuthorAvatar = styled(AuthorAvatar)`
  aspect-ratio: 1/1;

  position: relative;

  &::after {
    position: absolute;
    inset-block-start: -4.2px;
    inset-inline-start: 4.2px;
    content: "";

    inline-size: 100%;
    block-size: 100%;

    border: 2px solid #000000;
    border-radius: 50%;

    ${theme.breakpoints.up("tablet")} {
      inset-block-start: -7px;
      inset-inline-start: 7px;
    }
  }

  ${StyledEntityLink} {
    display: block;
    img {
      filter: none;
    }

    svg {
      display: block;

      inline-size: 99px;
      block-size: 99px;
      ${theme.breakpoints.up("tablet")} {
        inline-size: 166px;
        block-size: 166px;
      }
    }
  }
`;

export const AuthorName = styled.div`
  color: #333333;
  font-weight: 600;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 16px;
  letter-spacing: -0.16px;
  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    font-size: 24px;
    line-height: 26px;
    letter-spacing: -0.24px;
  }
`;
